/**
 * `paperNumber` is the question's place in the sitting (1 for the paper sat first).
 * `options.paperLabel` names the paper when that place is not its name: a TMUA Paper 2
 * section paper is sat first and alone, and is still "Paper 2".
 */
export function tagTmuaPaperQuestions(questions, paperNumber, paperId, options = {}) {
  const idPrefix = options.idPrefix || `tmua-p${paperNumber}`;
  const moduleKey = options.moduleKey;
  const paperLabel = options.paperLabel;
  return (questions || []).map((q, index) => ({
    ...q,
    id: `${idPrefix}-${index}-${q.db_id || q.external_id || q.id || 'q'}`,
    tmuaPaper: paperNumber,
    tmuaSourcePaperId: paperId,
    ...(moduleKey ? { pearsonModule: moduleKey } : {}),
    ...(paperLabel ? { tmuaPaperLabel: paperLabel } : {}),
  }));
}

export function getTmuaSittingQuestions(paper1, paper2, status) {
  if (status === 'ready' && Array.isArray(paper2) && paper2.length) {
    return [...paper1, ...paper2];
  }
  return Array.isArray(paper1) ? paper1 : [];
}

export function getPearsonSittingQuestions(modules) {
  const list = Array.isArray(modules) ? modules : [];
  return list.flatMap((mod) => (
    Array.isArray(mod?.questions) && mod.questions.length > 0 ? mod.questions : []
  ));
}

function isMcqStatsRow(q) {
  if (!q) return false;
  if (
    q.is_essay === true
    || q.interaction_kind === 'essay_choice_group'
    || (Array.isArray(q.essay_options) && q.essay_options.length > 0)
  ) {
    return false;
  }
  return true;
}

/** MCQ sitting score: unanswered is not correct. Essay rows are omitted from N. */
export function computeMcqSittingStats(list, userAnswers = {}) {
  const rows = (Array.isArray(list) ? list : []).filter(isMcqStatsRow);
  let correct = 0;
  rows.forEach((q) => {
    const ans = userAnswers[q.id];
    if (ans && ans.label === q.correct_answer) correct += 1;
  });
  const total = rows.length;
  const pct = total > 0 ? Math.round((correct / total) * 100) : 0;
  return {
    correct,
    total,
    pct: `${pct}%`,
    barCorrect: `${pct}%`,
    barIncorrect: `${100 - pct}%`,
  };
}
